// extracted by mini-css-extract-plugin
var _1 = "element__dVIme";
var _2 = "is-active__uTckp";
var _3 = "label__Z_O4y";
var _4 = "radio__eckMq";
export { _1 as "element", _2 as "is-active", _3 as "label", _4 as "radio" }
